
export default function Footer() {
  return (
    <>
      <footer className="bg-black text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400">&copy; 2025 BlackBook. All rights reserved.</p>
          <p className="text-gray-500 text-sm mt-2">
            BlackBook™ is a trademark of its respective owners. Unauthorized use is strictly prohibited.
          </p>
          <div className="flex justify-center space-x-4 mt-4 text-sm">
            <a href="#" className="text-gray-400 hover:text-white">Privacy Policy</a>
            <span className="text-gray-600">|</span>
            <a href="#" className="text-gray-400 hover:text-white">Terms of Use</a>
          </div>
          

          <p className="text-gray-600 text-xs mt-4">Powered by Exorion &copy; 2025</p>
          <div className="mt-2">
            <a href="/admin" className="text-gray-400 hover:text-white text-xs">Admin Access</a>
          </div>
        </div>
      </footer>
      
      <div className="bg-black text-center py-4">
        <p className="text-yellow-500 text-sm font-medium">
          Supporting Black Professional businesses - from established enterprises to young entrepreneurs.
        </p>
        <p className="text-yellow-400 text-xs mt-1">Inspired by the Green Book. Built for the future.</p>
      </div>
    </>
  );
}